import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { compareNumericAscending } from '@app/helpers';
import { MailRecipientSelectorData, PortalUserListItem } from '@app/models';

@Component({
    selector: 'app-recipient-selector',
    templateUrl: './recipient-selector.component.html',
    styleUrls: ['./recipient-selector.component.scss'],
    standalone: false
})
export class RecipientSelectorComponent implements OnInit {

  @Input('mailRecipientData') mailRecipientData: MailRecipientSelectorData | null = null;
  @Input('disabled') disabled: boolean = false;
  @Output('valueChanges') valueChanges: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('sheetTemp') sheetTemp!: TemplateRef<any>;
  
  recipientValues: PortalUserListItem[] = [];
  recipientListValues: {data: PortalUserListItem; checked: boolean}[] = [];
  
  constructor(private readonly _bottomSheet: MatBottomSheet) {}

  openSheet(): void {
    if (!!this.disabled) return;
    let prevSelectedIDs = this.recipientValues.map(tag => tag.id);
    this.recipientListValues = this.mailRecipientData?.availableRecipients?.map(record => ({
        data: record, 
        checked: prevSelectedIDs.includes(record.id)
      })) || [];
    this._bottomSheet.open(this.sheetTemp, { panelClass: 'tag-selector-sheet', disableClose: true });
  }
  
  ngOnInit(): void {
    this.initiateValues();
  }

  initiateValues(data: MailRecipientSelectorData | null = this.mailRecipientData) {
    this.mailRecipientData = data;
    this.recipientValues = [];
    this.recipientListValues = [];
    data?.availableRecipients?.forEach(record => {
      if (data.values.includes(record.id)) {
        this.recipientValues = [ ...this.recipientValues, {...record} ];
      }
    });
  }

  closeForm(resetValues: boolean = false) {
    if (resetValues) {
      let prevSelectedIDs = this.recipientValues.map(tag => tag.id);
      this.recipientListValues = this.recipientListValues.map(record => ({ ...record, checked: prevSelectedIDs.includes(record.data.id) }));
    } else {
      this.recipientValues = [...this.recipientListValues.filter(record => record.checked).map(record => ({ ...record.data }))];
    }
    this._bottomSheet.dismiss();
    this.valueChanges.emit();
  }

  removeRecipient(id: number) {
    if (!!this.disabled) return;
    this.recipientValues = this.recipientValues.filter(record => (record.id != id));
  }

  listChange(checked: any, index: number) {
    this.recipientListValues[index].checked = !!checked;
  }

  clearAll() {
    this.recipientListValues = this.recipientListValues.map(record => ({...record, checked: false }));
  }

  reset() {
    this.initiateValues(this.mailRecipientData);
  }

  get selectedRecipients() {
    return this.recipientValues;
  }

  get selectedRecipientIds() {
    return this.selectedRecipients.map(record => record.id).sort(compareNumericAscending);
  }

  get reachedMaxLimit(): boolean {
    return this.recipientListValues.filter(record => !!record.checked).length >= 8;
  }

  trackByFn(index: number, item: any): number { 
    return index; 
  }

}
